<template>
  <div class="iNewsWrap">
    <div class="mainTi">{{ $t('NAV.NEWS') }}</div>
    <div class="iNewsCont">
      <div class="dimTemporarilyCome" v-if="newsData.length == 0">{{ $t('MSG.COMING') }}</div>
      <div class="iNewsBox" v-for="news in newsData" :key="news.id">
        <div class="pic"><router-link :to="`/${$i18n.locale}/newsView/${news.id}`"><img :src="news.pic" :alt="news.title"></router-link></div>
        <div class="cont">
          <div class="ti"><router-link :to="`/${$i18n.locale}/newsView/${news.id}`">{{ news.title }}</router-link></div>
          <div class="txt">{{ news.shortDetail }}</div>
        </div>
      </div>

    </div>
  </div>
</template>

<style>
.iNewsBox:nth-child(3) {
  border-right: 0;
}
</style>

<script>
export default {
  data () {
    return {
      newsData: []
    }
  },
  created () {
    fetch('./news.json')
      .then(rs => rs.json())
      .then(rs => {
        // console.log('news', rs)
        this.newsData = rs
      })
  }
}
</script>
